import { FC } from 'react';
import { XmlField } from './styled';

type Props = {
  defaultValue: string | undefined;
  rows: number;
  name: string;
  onChange: (name: string, value: string) => void;
};

const XmlInputField: FC<Props> = ({ defaultValue, name, rows, onChange }) => {
  return (
    <XmlField
      defaultValue={defaultValue}
      id={name}
      rows={rows}
      onChange={(e) => onChange(name, e.target.value)}
    ></XmlField>
  );
};

export default XmlInputField;
